import './index.scss'

const Marger = () => {
  return (
    <div className="merger">
      <span className='top'></span>
      <div className='vert'>
        <span></span>
        <i className="icon icon--qr-code"></i>
        <span></span>
      </div>
      <span className='bottom'></span>
    </div>
  )
}

export default Marger